import { render, staticRenderFns } from "./TemplateDashboardContainer.vue?vue&type=template&id=26a4a311"
import script from "./TemplateDashboardContainer.vue?vue&type=script&lang=js"
export * from "./TemplateDashboardContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports